import { ApiImageClient } from "@/api";

async function apiUserGetDepartment({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.get(
      `/departments/${id}?populate=*`,
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserGetDepartment_Error", e);
    return e;
  }
}

async function apiUserGetDepartments() {
  try {
    const result = await ApiImageClient.get(`/departments/`).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserGetDepartments_Error", e);
    return e;
  }
}

async function apiUserPutDepartment({ id, data }) {
  try {
    const result = await ApiImageClient.put(`/departments/${id}`, {
      data,
    }).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserPutDepartment_Error", e);
    return e;
  }
}

async function apiUserPostDepartment({ data }) {
  try {
    const result = await ApiImageClient.post(`/departments`, { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (error) {
    console.error("apiUserPostDepartment_Error", error);
    return error;
  }
}

async function apiUserDeleteDepartment({ id }) {
  try {
    const result = await ApiImageClient.delete(`/departments/${id}`).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserDeleteDepartment_Error", e);
    return e;
  }
}

export {
  apiUserGetDepartment,
  apiUserGetDepartments,
  apiUserPutDepartment,
  apiUserDeleteDepartment,
  apiUserPostDepartment,
};
